import React, { useState } from 'react';
import './index.scss';
import { Tabs, TabsProps } from 'antd';
import IssueRecord from '../IssueRecord';
import EventRecord from '../EventRecord';
import ManualEventRecord from '../ManualEventRecord';
import { analyzeLog } from '@/utils/util';
const tabs: TabsProps['items'] = [
  {
    label: '工单记录',
    key: 'ISSUE_LIST',
  },
  {
    label: '事件记录',
    key: 'EVENT_LIST',
  },
  {
    label: '人工记录',
    key: 'CALL_FRONT_LIST',
  },
];
const IssueHistory = (props: { vehicleName: string }) => {
  const { vehicleName } = props;
  const [tabKey, setTabKey] = useState<string>(tabs[0].key);
  return (
    <div className="issue-history-content">
      <Tabs
        items={tabs}
        defaultActiveKey={tabKey}
        onChange={(tabKey: string) => {
          setTabKey(tabKey);
          analyzeLog(tabKey, '');
        }}
      ></Tabs>
      {tabKey === 'ISSUE_LIST' ? (
        <IssueRecord vehicleName={vehicleName} />
      ) : tabKey === 'EVENT_LIST' ? (
        <EventRecord vehicleName={vehicleName} />
      ) : (
        <ManualEventRecord vehicleName={vehicleName} />
      )}
    </div>
  );
};

export default IssueHistory;
